import { createModalController } from '../shared/modal-controller';

createModalController({
    popupSelector: '.StudiesModal',
    modalInnerSelector: '.StudiesModal__inner',
    openTriggerSelector: '#open-studies-modal',
    closeTriggerSelector: ['.StudiesModal__continue', '.StudiesModal__close'],
});
